import * as React from 'react';
export const SvgPoly = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" viewBox="0 0 16 10" {...props}>
    <path
      d="M16 .972l-.032-.548-.159.457-.891.792-1.021.161-.306-.3.892-1.256.92-.278-.992.022-1.442 1.063-1.352-.099 1.356.943.668.479L11.606.954 9.716 0 8.592.227 5.095 3.186l-1.683.552-.694.72-1.244.014-.611 1.162L0 5.886l.816.117.759-1.041 1.168.248-.018 1.11-.586 1.605-.334 1.483-.36.592.914-.205-.105-.606.773-1.63 1.5-.61.579-.975.978-.727 1.938.292 1.96-.873-.335 1.377-.87.08-.248 1.137.747-.508 1.23-.544.967-1.535.058-.73.521.547 1.507.958.852-.41-.05-2.035-.245-.785 1.118-.285z"
      fill="currentColor"
    />
  </svg>
);
